import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'gatsby'
import Img from 'gatsby-image'

import Arrow from '../Arrow'
import { backgroundImage } from '../../styles'
import translations from '../../translations'
import { flattenImage } from '../../utils'

const CaseTeaser = ({ content, slug }) => (
  <Teaser data-aos="fade-up" data-aos-delay="50">
    <TeaserLink
      title={content.title.text}
      to={`${translations.paths.cases.path}/${slug}`}
    >
      <ImageContainer>
        {content.teaserImage.localFile ? (
          <Img
            fluid={flattenImage(content.teaserImage)}
            style={backgroundImage}
            imgStyle={{
              transition:
                'transform 2000ms cubic-bezier(0.190, 1.000, 0.220, 1.000)',
            }}
          />
        ) : (
          <ImageWrapper style={backgroundImage}>
            <StyledImg src={content.teaserImage.url} />
          </ImageWrapper>
        )}
      </ImageContainer>
      {content.logo && <Logo alt={content.logo.alt} src={content.logo.url} />}
      <div>
        <Client>{content.client.text}</Client>
        <Title>{content.title.text}</Title>
        <Arrow color="white" />
      </div>
    </TeaserLink>
  </Teaser>
)

CaseTeaser.propTypes = {
  content: PropTypes.shape({
    client: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }).isRequired,
    logo: PropTypes.shape({
      alt: PropTypes.string,
      url: PropTypes.string,
    }),
    teaserImage: PropTypes.shape({
      localFile: PropTypes.shape({
        childImageSharp: PropTypes.shape({
          fluid: PropTypes.shape({}).isRequired,
        }).isRequired,
      }),
      url: PropTypes.string,
    }).isRequired,
    title: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  slug: PropTypes.string.isRequired,
}

const Teaser = styled.div`
  grid-column-end: span 1;
  grid-row-end: span 2;
  position: relative;
  width: 100%;
  &::after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  @media (min-width: 1024px) {
    &:nth-child(3n + 0) {
      grid-row-end: span 1;

      &::after {
        padding-bottom: 50%;
      }
    }
  }
`

const TeaserLink = styled(Link)`
  background-color: rgba(0, 9, 35, 0.2);
  border-bottom: none;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 25px;
  position: absolute;
  width: 100%;
  justify-content: space-between;

  &:hover svg {
    transform: translateX(-100%);

    & + svg {
      transform: translateX(0);
    }
  }

  @media (min-width: 768px) {
    padding: 50px;
  }
`

const ImageWrapper = styled.div`
  overflow: hidden;
`

const ImageContainer = styled.div`
  height: 100%;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;

  &:hover img {
    transform: scale(1.03);
  }
`

const StyledImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  transition: transform 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0.5s;
`

const Logo = styled.img`
  align-self: baseline;
  @media (max-width: 1100px) {
    transform: scale(0.75);
  }
`

const Client = styled.span`
  color: white;
  font-weight: 800;
  font-size: 14px;
  margin-bottom: 10px;
  text-transform: uppercase;
`

const Title = styled.h2`
  color: white;
  font-family: ${props => props.theme.fontFamily.serif};
  font-size: 30px;
  line-height: 40px;
  margin: 0 0 10px;
  max-width: 400px;

  @media (min-width: 768px) {
    font-size: 35px;
    line-height: 45px;
  }
`

export default CaseTeaser
